module.exports = __webpack_public_path__ + "img/XXJKQ_AppImage.ce6ed68b.png";